import axios from "axios";
import api from "~/services/api";

const createHeader = (firstAccessToken, access_token, method) => {
  const header = {
    "Content-Type": "application/json",
  };

  if (firstAccessToken) {
    header["X-First-Access-Token"] = firstAccessToken;
  }

  if (access_token) {
    header["access_token"] = access_token;
    header["client_id"] = process.env.REACT_APP_CLIENT_ID;
  }

  const parameters = {
    method,
    headers: header,
  };

  return parameters;
};

export const getEmails = (url, firstAccessToken, access_token) => {
  var parameters = createHeader(firstAccessToken, access_token, "GET");
  return api.get(`${url}/contacts?contact-type=EMAIL`, parameters);
};

export const getPhones = (url, firstAccessToken, access_token) => {
  var parameters = createHeader(firstAccessToken, access_token, "GET");
  return api.get(`${url}/contacts?contact-type=PHONE`, parameters);
};

export const sendToken = (body, url, firstAccessToken, access_token) => {
  var parameters = createHeader(firstAccessToken, access_token, "POST");
  return api.post(`${url}/tokens`, body, parameters);
};

export const postWithEmail = (body, url, firstAccessToken, access_token) => {
  var parameters = createHeader(firstAccessToken, access_token, "POST");
  return api.post(`${url}/passwords`, body, parameters);
};

export const postWithPhone = (body, url, firstAccessToken, access_token) => {
  var parameters = createHeader(firstAccessToken, access_token, "POST");
  return api.post(
    `${url}/contacts`,
    { contact: body.mail, contactType: "EMAIL", token: body.smsCode },
    parameters
  );
};
